<template>
  <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>
    <span class="cursor-pointer flex items-center i18n-locale">
      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('en')"> &nbsp;English
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('fr')">&nbsp;French
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>

export default {
  computed: {
    getCurrentLocaleData () {
      const locale = this.$i18n.locale;
      if (locale === 'en') return {
        flag: 'us',
        lang: 'English'
      };
      else if (locale === 'fr') return {
        flag: 'fr',
        lang: 'French'
      };
    }
  },
  methods: {
    updateLocale (locale) {
      this.$root.$i18n.locale = locale;
      this.$root.$moment.locale(locale);
      this.$root.$validator.localize(locale);
    }
  }
};
</script>
